export { default } from "./FAQs"
